import { vDate, vObject, vOptional, type vOutput } from '../validation/index.ts'
import type { Currency } from './common.ts'

export const exchangeRateQuerySchema = vObject({
  date: vOptional(vDate()),
})

export type ExchangeRateQuery = vOutput<typeof exchangeRateQuerySchema>

export type ExchangeRateMap = Partial<Record<Currency, number>>

export type LoadExchangeRates = ExchangeRateMap & {
  date: Date
}
